import { ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { FlightsFacade } from "src/app/pages/flights-page/src/app/data-access/services/flights.facade";
import { parseDuration, parseLocation } from "src/app/pages/flights-page/src/app/ui/utils/flights-page.utils";
import { SortValueEnum } from "src/app/libs/ui/components/top-bar/enums/top-bar.enum";
import { FlightPageUtils } from "src/app/pages/flights-page/src/app/data-access/utils/flights-page.utils";
import { HomePageUtils } from "src/app/pages/home-page/src/app/ui/utils/home-page.utils";
import { TokenStorageService } from "src/app/core/services/token-storage.service";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { EventsFacade } from "src/app/pages/events/src/app/data-access/services/events.facade";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { cloneDeep, isEqual } from "lodash";
import { DatePipe, Location } from '@angular/common';
import { MatDialog } from "@angular/material/dialog";
import { OrderDialogModule } from "src/app/libs/ui/components/order-dialog/order-dialog.module";
import { OrderDialogComponent } from "src/app/libs/ui/components/order-dialog/order-dialog.component";
@Component({
  selector: "tic-trip-summary",
  templateUrl: "./trip-summary.component.html",
  styleUrls: ["./trip-summary.component.scss"],
})
export class TripSummaryComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  loadedFlight: any = {};
  loadedFlightFlag: boolean = false;
  loadedHotel: any = {};
  loadedHotelVo: any = {};
  loadedHotelFlag: boolean = false;
  loadedHotelFlagVo: boolean = false;
  loadedEvent: any = {};
  eventList: any = {};
  loadedEventFlag: boolean = false;
  orderDetail: any = {};
  data: any = {};
  totalCost: number = 0;
  packagePrice: number = 0;
  eventPrice: number = 0;
  flightPrice: number = 0;
  hotelPrice: number = 0;
  pickLuggage = false;
  isflightOpen = false;
  iseventOpen = false;
  orderCallFlag = false;
  eventCallFlag = false;
  hotelCallFlag = false;
  flightCallFlag = false;
  paxCallFlag = false;
  readonly parseDuration = parseDuration;
  readonly parseLocation = parseLocation;
  packageTypeId!: number;
  params = { sort: SortValueEnum.TotalAmountDesc };
  flightResults: any = [];
  fixedFlightResults: any = [];
  selectedEvents: any[] = [];
  eventAdditionalPrice = 0;
  eventCount = 0;
  count = 0;
  selectedRoom: any;
  selectedRoomOptions: string = "";
  selectedRoomOptionsPrice = 0;
  packageType = [
    'summaryCard.packageType.TicketFlightHotel',
    'summaryCard.packageType.TicketFlight',
    'summaryCard.packageType.TicketHotel',
   ];
  totalPeoples = 0;
  daysBetween: number;
  private orderIds:string[]=[];
  isViewOrder: boolean = false;

  constructor(
    public flightFacade: FlightsFacade,
    public eventFacade: EventsFacade,
    public facadeCheckout: CheckoutFacade,
    private routerService: RouterService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.initializeRouteParamsSubscription();
    this.subscribeToFacadeCheckoutData();
  }

  private initializeRouteParamsSubscription(): void{
    this.routerService
      .getUrlParams()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.handleUrlParams(res);
      });
  
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        if(res["orderDetail"] && res["viewOrder"]) {
          this.isViewOrder = true;
          const decodedOrderDetail = JSON.parse(atob(res["orderDetail"]));
          this.facadeCheckout.getOrder({
            orderId: decodedOrderDetail.orderId,
            email: decodedOrderDetail.email,
          });
        }
      }
    });
  }

  private handleUrlParams(res: any): void {
    const startDate = new Date(res["inboundDate"]);
    const endDate = new Date(res["outboundDate"]);
    this.daysBetween = this.getDates(startDate, endDate);
    this.data = res;
    if (this.isObjectNotEmpty(this.data)) {
      this.packageTypeId = this.data.packageType;
      this.totalPeoples =
        parseInt(res["numberOfAdults"]) + parseInt(res["numberOfChildren"]);
    }
  }

  private subscribeToFacadeCheckoutData(): void {
    if( !this.isViewOrder ) {
      this.facadeCheckout.vm$.pipe(
        distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
        takeUntil(this.destroy$)
      ).subscribe((data) => {
        this.handleFacadeCheckoutData(data);
      });
    }

    this.facadeCheckout.orderInfo$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      if (data && this.isObjectNotEmpty(data)) {
        this.orderDetail = data;
        if( data?.error ) {
          this.orderCallFlag = false;
        } else {
          this.setPaxes(data);
          this.orderCallFlag = true;
          this.totalCost = data.finance.cost;
          this.totalPeoples = data.passengers.length;
          const startDate = new Date(data.dates.from);
          const endDate = new Date(data.dates.to);
          this.daysBetween = this.getDates(startDate, endDate);
          if( data.eventInfo ) {
            this.loadedEventFlag = true;
            this.loadedEvent = data.eventInfo;
          }
          if( data.flightInfo ) {
            this.loadedFlightFlag = true;
            this.loadedFlight = data.flightInfo;
          }
          if( data.hotelInfo ) {
            this.loadedHotelFlag = true;
            this.loadedHotel = data.hotelInfo;
          }
        }
      }
    });

    this.facadeCheckout.eventOrdersDetailInfo$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (
        data &&
        this.isObjectNotEmpty(data)
      ) {
        if (this.selectedEvents.length === 0) {
          this.selectedEvents = [];
        }
        this.loadedEvent = data;
        this.loadAllOrderDetail(this.orderDetail);
        this.eventList = data;
        this.eventCallFlag = true;
        this.loadedEventFlag = true;
      }
    });

    this.facadeCheckout.flightOrderInfo$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (
        data &&
        !this.flightCallFlag
      ) {
        if(this.isObjectNotEmpty(data)){
          this.loadedFlight = data.flightOrder?.data;
          this.flightCallFlag = true;
          this.loadedFlightFlag = true;
        }
      }
      else{
        this.flightCallFlag=true;
      }
      this.cdr.detectChanges();
    });

    this.facadeCheckout.hotelOrderInfo$.pipe(
      distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      if (
        data &&
        !this.hotelCallFlag
      ) {
        if(this.isObjectNotEmpty(data)){
          this.loadedHotelVo = data.hotel;
          this.hotelCallFlag = true;
          this.loadedHotelFlagVo = true;
        }
      }
      else{
        this.hotelCallFlag=true;
      }
    });
  }

  private handleFacadeCheckoutData(data: any): void {
    if (data && data.events && data.events.length > 0) {
      this.loadedEvent = data.events;
      this.eventList = data.events;
      this.loadedEventFlag = true;
      this.eventCount = data.events.length;
    }
    if (this.isObjectNotEmpty(this.data)) {
      if (data && data.flight) {
        this.loadedFlight = data.flight;
        if (this.isObjectNotEmpty(this.loadedFlight)) {
          this.loadedFlightFlag = true;
        }
      }
      if (data && data.hotel) {
        this.loadedHotel = data.hotel;
        if (this.isObjectNotEmpty(this.loadedHotel)) {
          this.loadedHotelFlag = true;
        }
      }
      if (data && data.packagePrice) {
        this.packagePrice = data.packagePrice;
      }
      if (data && data.totalPrice) {
        this.totalCost = data.totalPrice;
      }
      if (data && data.flightPrice) {
        this.flightPrice = data.flightPrice;
      }
      if (data && data.hotelPrice) {
        this.hotelPrice = data.hotelPrice;
      }
      if (data && data.eventPrice) {
        this.eventAdditionalPrice = data.eventPrice;
        this.eventPrice = data.eventPrice;
      }
      if (data && data.room) {
        this.selectedRoom = data.room;
      }
    } else {
      // if (data && data.orderInfo && this.isObjectNotEmpty(data.orderInfo)) {
      //   this.orderDetail = data.orderInfo;
      //   this.loadAllOrderDetail(data.orderInfo);
      //   this.orderCallFlag = true;
      //   if (
      //     this.isObjectNotEmpty(data.orderInfo) &&
      //     !this.isObjectNotEmpty(this.data)
      //   ) {
      //     this.totalCost = data.orderInfo.finance.cost;
      //     this.totalPeoples = data.orderInfo.passengers.length;
      //     const startDate = new Date(data.orderInfo.dates.from);
      //     const endDate = new Date(data.orderInfo.dates.to);
      //     this.daysBetween = this.getDates(startDate, endDate);
      //   }
      // }
      // if (
      //   data &&
      //   this.isObjectNotEmpty(data.eventOrdersDetailInfo)
      // ) {
      //   if (this.selectedEvents.length === 0) {
      //     this.selectedEvents = [];
      //   }
      //       this.loadedEvent = data.eventOrdersDetailInfo;
      //       this.loadAllOrderDetail(data.orderInfo);
      //       this.eventList = data.eventOrdersDetailInfo;
      //       this.eventCallFlag = true;
      //       this.loadedEventFlag = true;
      // }
      
    }
  }

  private setPaxes(order:any): void  {
    if (!this.paxCallFlag) {
      let paxDetails: any[] = [];
      if (order.passengers.length > 0) {
        for (let i = 0; i < order.passengers.length; i++) {
          paxDetails.push({
            dob: order.passengers[i].dob,
            firstAndMiddleName: order.passengers[i].firstAndMiddleName,
            lastName: order.passengers[i].lastName,
            nationality: order.passengers[i].nationality,
            passportNumber: order.passengers[i].passportNumber,
            type: order.passengers[i].type,
          });
        }
      }
      if (order.contactDetail) {
        this.facadeCheckout.setPassangerDetail({
          firstNameContactControl: order.contactDetail.firstName,
          lastNameContactControl: order.contactDetail.lastName,
          mobileNoContactControl: order.contactDetail.mobileNo,
          emailContactControl: order.contactDetail.email,
          paxFormData: paxDetails,
        });
      }
      this.paxCallFlag = true;
    }
  }

  private loadAllOrderDetail(order:any): void {
    if (
      this.isObjectNotEmpty(order)
    ) {
      if (
        order.ticketsOrders &&
        order.ticketsOrders.length > 0
      ) {
        this.orderIds = [];
        this.eventPrice = 0;
        for (let i = 0; i < order.ticketsOrders.length; i++) {
          if(order.ticketsOrders[i]?.orderId!==''){
            this.orderIds.push(order.ticketsOrders[i]?.orderId);
            this.eventPrice += order.ticketsOrders[i].customerCost;
          }
          else{
            this.eventCallFlag=true;
          }
        }
          this.facadeCheckout.getEventOrdersDetail({
            orderIds: this.orderIds,
          });
          this.facadeCheckout.setEvent(this.selectedEvents);
          this.facadeCheckout.setEventPrice(this.eventPrice);
      }
      if (!this.paxCallFlag) {
        let paxDetails: any[] = [];
        if (order.passengers.length > 0) {
          for (let i = 0; i < order.passengers.length; i++) {
            paxDetails.push({
              dob: order.passengers[i].dob,
              firstAndMiddleName: order.passengers[i].firstAndMiddleName,
              lastName: order.passengers[i].lastName,
              nationality: order.passengers[i].nationality,
              passportNumber: order.passengers[i].passportNumber,
              type: order.passengers[i].type,
            });
          }
        }
        if (order.contactDetail) {
          this.facadeCheckout.setPassangerDetail({
            firstNameContactControl: order.contactDetail.firstName,
            lastNameContactControl: order.contactDetail.lastName,
            mobileNoContactControl: order.contactDetail.mobileNo,
            emailContactControl: order.contactDetail.email,
            paxFormData: paxDetails,
          });
        }
        this.paxCallFlag = true;
      }
      if (order.flightOrder.orderId !== "" && !this.flightCallFlag) {
        this.facadeCheckout.getFlightOrder({
          orderId: order.flightOrder?.orderId,
        });
        this.facadeCheckout.setFlight(this.loadedFlight);
      }

      if (order.hotelOrder.orderId !== "" && !this.hotelCallFlag) {
        this.facadeCheckout.getHotelOrder({
          bookingId: order.hotelOrder?.orderId,
        });
        this.facadeCheckout.setHotel(this.loadedHotel);
      }
    }
  }

  private isObjectNotEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  private getDates(startDate: Date, endDate: Date): number {
    const startMillis = startDate.getTime();
    const endMillis = endDate.getTime();
    const differenceMillis = endMillis - startMillis;
    const differenceDays = differenceMillis / (1000 * 60 * 60 * 24);
    return Math.round(differenceDays);
  }

  private loadFlights(data: any): void {
    const requestQuery = FlightPageUtils.getRequestQuery(data);
    this.flightFacade.loadInitialFlightData(requestQuery);
  }

  eventValidation(event: any): void {
    if (!Array.isArray(this.loadedEvent)) {
        console.error('loadedEvent is not an array');
        return;
    }

    // Ensure loadedEvent is extensible
    if (Object.isFrozen(this.loadedEvent) || !Object.isExtensible(this.loadedEvent)) {
        this.loadedEvent = [...this.loadedEvent]; // Create a shallow copy to make it extensible
    }

    // Check if event data exists and length is less than 1
    if (event.data && event.data.length < 1) {
        // Remove event from array
        this.loadedEvent = this.loadedEvent.filter(selectedEvent => selectedEvent.Id !== event.Id);
    } else {
        // Find index of existing event
        const existingEventIndex = this.loadedEvent.findIndex(selectedEvent => selectedEvent.Id === event.Id);

        // Update or append event based on existence
        if (existingEventIndex !== -1) {
            // Update existing event with the new event object
            this.loadedEvent = this.loadedEvent.map((selectedEvent, index) => 
                index === existingEventIndex ? event : selectedEvent
            );
        } else {
            // Append new event to array
            this.loadedEvent = [...this.loadedEvent, event];
        }
    }
  }

  private appendEvent(event: any): void {
    const existingPersonIndex = this.loadedEvent.findIndex(
      (selectedEvents: any) => selectedEvents.Id === event.Id
    );
    if (existingPersonIndex === -1) {
      this.loadedEvent = [...this.loadedEvent, event];
      this.eventList = this.loadedEvent;
    }
  }

  onSelectCheckout(): void {
    if (this.isObjectNotEmpty(this.data)) {
      this.routerService.navigateAndAddParamsToUrl(
        this.data,
        false,
        PagesRoute.TripCheckout
      );
    } else {
      const adultCount: number = this.orderDetail.passengers.filter(
        (person) => person.type === "adult"
      ).length;
      const childCount: number = this.orderDetail.passengers.filter(
        (person) => person.type === "child"
      ).length;
      this.routerService.navigateAndAddParamsToUrl(
        {
          numberOfAdults: adultCount,
          numberOfChildren: childCount,
        },
        false,
        PagesRoute.TripCheckout
      );
    }
  }

  luggagepopup(): void {
    this.pickLuggage = !this.pickLuggage;
  }

  selectopt(event: Event): void {
    const button = event.target as HTMLButtonElement;
    const closestContainer = button.closest(".luggage-options");
    if (closestContainer) {
      const buttonsInContainer =
        closestContainer.querySelectorAll(".luggage-option");
      buttonsInContainer.forEach((btn: Element) => {
        if (btn !== button) {
          (btn as HTMLButtonElement).classList.remove("active");
        }
      });
    }
    button.classList.toggle("active");
  }

  openPopup(): void {
    this.isflightOpen = true;
  }

  closePopup(): void {
    this.isflightOpen = false;
  }

  ClickedOut(event: Event): void {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("flight-popup")) {
      this.isflightOpen = false;
    }
  }

  openPopupevt(): void {
    this.iseventOpen = true;
  }

  closePopupevt(): void {
    this.iseventOpen = false;
  }

  ClickedOutevt(event: Event): void {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("event-popup")) {
      this.iseventOpen = false;
    }
  }

  trackById(index: number, hotel: any): number | string {
    return hotel.id;
  }

  onSelectedFlight(flightOfferParams: any): void {
    this.closePopup();
    const { flightOfferId, flightOfferPrice } = flightOfferParams.event;
    const { flightOfferPriceCurrency } = flightOfferParams.event;
    this.data = HomePageUtils.finalizedObjectData(this.data);
    this.data.inboundDate = this.data.inbound.date;
    this.data.outboundDate = this.data.outbound.date;
    //this.data = HomePageUtils.finalizedObjectDataTemp(this.data);
    this.tokenStorage.saveData("flightPrice", flightOfferPrice);
    this.tokenStorage.saveData("currency", flightOfferPriceCurrency);
    const updatedFlightPrice = flightOfferPrice;
    //const updatedPrice = this.totalCost - this.flightPrice + updatedFlightPrice;
    let updatedTotalPrice;
    updatedTotalPrice = this.eventPrice + this.hotelPrice + parseFloat(flightOfferParams.flight.actual_amount);
    this.totalCost = updatedTotalPrice;
    this.facadeCheckout.setTotalPrice(updatedTotalPrice);
    this.facadeCheckout.setFlightPrice(updatedFlightPrice);
    this.flightPrice = updatedFlightPrice;
    let forwardRoute = "";

    // forwardRoute = PagesRoute.TripSummary;
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { ...this.data, flightOfferId },
    //   queryParamsHandling: "merge",
    // });

    this.flightFacade.vm$
      .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe((res) => {
        this.destroy$.next(null);
        this.loadedFlight = res.flights[flightOfferId];
        this.facadeCheckout.setFlight(this.loadedFlight);
        this.loadedFlightFlag = true;
      });
      this.updateFlightID('flightId',flightOfferId);
  }

  updateFlightID(paramName: string, newValue: string): void {
    // Get the current URL
    let currentUrl = this.location.path();

    // Find the index of the parameter in the URL
    let index = currentUrl.indexOf(`${paramName}=`);

    if (index !== -1) {
      // If the parameter exists, find the end index of its value
      let endIndex = currentUrl.indexOf('&', index);
      if (endIndex === -1) {
        endIndex = currentUrl.length; // If it's the last parameter
      }

      // Replace the parameter's value with the new value
      let newUrl = currentUrl.substring(0, index) + `${paramName}=${newValue}` + currentUrl.substring(endIndex);

      // Update the browser's history without reloading the page
      this.location.replaceState(newUrl);
    } else {
      // If the parameter doesn't exist, append it to the URL
      let delimiter = currentUrl.includes('?') ? '&' : '?';
      let newUrl = currentUrl + `${delimiter}${paramName}=${newValue}`;

      // Update the browser's history without reloading the page
      this.location.replaceState(newUrl);
    }
  }

  eventSelection(event: any): void {
    this.eventValidation(event.event);
    this.appendEventUrlParameter(event.event.Id, event.event.data[0].ciid, event.event.data[0].seats);
    const allEvents = cloneDeep(this.loadedEvent);
    this.facadeCheckout.setEvent(allEvents);
    let amount: number = 0;
    amount = allEvents.reduce(
      (sum: number, item: any) => sum + item.totalActualPrice,
      0
    );
    const totalPrice = this.totalCost - this.eventPrice + amount;
    this.totalCost = totalPrice;
    const packagePrice = this.packagePrice - this.eventPrice + amount;
    this.eventAdditionalPrice = amount;
    this.facadeCheckout.setEventPrice(this.eventAdditionalPrice);
    this.facadeCheckout.setPackagePrice(packagePrice);
    this.facadeCheckout.setTotalPrice(totalPrice);
    this.eventCount = this.loadedEvent.length;
    this.iseventOpen = false;
  }

  appendToUrlParameter(paramName: string, newValue: string): void {
    let currentUrl = this.location.path();
    const urlParts = currentUrl.split('?');
    let baseUrl = urlParts[0];
    let queryParams = {};
    if (urlParts.length > 1) {
      const queryString = urlParts[1];
      const queryParts = queryString.split('&');
      queryParts.forEach(part => {
        const keyValue = part.split('=');
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1]);
        queryParams[key] = value;
      });
    }
    if (queryParams[paramName]) {
      let paramValues = queryParams[paramName].split(',');
      if (!paramValues.includes(newValue)) {
        paramValues.push(newValue);
      }
      queryParams[paramName] = paramValues.join(',');
    } else {
      queryParams[paramName] = newValue;
    }
    const newQueryString = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${queryParams[key]}`)
      .join('&');
    const newUrl = `${baseUrl}?${newQueryString}`;
    this.location.replaceState(newUrl);
  }

  appendEventUrlParameter(eventOfferId: string, catId: string, seats: string): void {
    let currentUrl = this.location.path();
    const urlParts = currentUrl.split('?');
    let baseUrl = urlParts[0];
    let queryParams = {};
    if (urlParts.length > 1) {
      const queryString = urlParts[1];
      const queryParts = queryString.split('&');
      queryParts.forEach(part => {
        const keyValue = part.split('=');
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1]);
        queryParams[key] = value;
      });
    }
  
    // Get the current values of eventOfferId, catId, and seats
    let eventOfferIdValues = queryParams['eventOfferId'] ? queryParams['eventOfferId'].split(',') : [];
    let catIdValues = queryParams['catId'] ? queryParams['catId'].split(',') : [];
    let seatsValues = queryParams['seats'] ? queryParams['seats'].split(',') : [];
  
    // Find the index of the eventOfferId
    let index = eventOfferIdValues.indexOf(eventOfferId);
  
    if (index !== -1) {
      // Update the catId and seats at the same index
      catIdValues[index] = catId;
      seatsValues[index] = seats;
    } else {
      // If eventOfferId is not found, add new entries
      eventOfferIdValues.push(eventOfferId);
      catIdValues.push(catId);
      seatsValues.push(seats);
    }
  
    // Update the query parameters with the new values
    queryParams['eventOfferId'] = eventOfferIdValues.join(',');
    queryParams['catId'] = catIdValues.join(',');
    queryParams['seats'] = seatsValues.join(',');
  
    const newQueryString = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${queryParams[key]}`)
      .join('&');
    const newUrl = `${baseUrl}?${newQueryString}`;
    this.location.replaceState(newUrl);
  }

  isEventLoaded(eventId: number): boolean {
    return this.loadedEvent.some(
      (event: { Id: number }) => event.Id === eventId
    );
  }

  eventsUpdate(event: any): void {
    this.eventValidation(event.event);
    const allEvents = cloneDeep(this.loadedEvent);
    let amount: number = 0;
    amount = allEvents.reduce(
      (sum: number, item: any) => sum + item.totalActualPrice,
      0
    );
    const totalPrice = this.totalCost - this.eventPrice + amount;
    this.totalCost = totalPrice;
    const packagePrice = this.packagePrice - this.eventPrice + amount;
    this.eventPrice = amount;
    this.eventCount = this.loadedEvent.length;
    this.facadeCheckout.setEvent(allEvents);
    this.facadeCheckout.setPackagePrice(packagePrice);
    this.facadeCheckout.setEventPrice(this.eventPrice);
    this.facadeCheckout.setTotalPrice(totalPrice);
    this.updateCat(event.event);
  }

  updateCat(event: any) {
    let currentUrl = this.location.path();

    // Extract the query parameters
    const urlParts = currentUrl.split('?');
    let baseUrl = urlParts[0];
    let queryParams = {};
    if (urlParts.length > 1) {
      const queryString = urlParts[1];
      const queryParts = queryString.split('&');
      queryParts.forEach(part => {
        const keyValue = part.split('=');
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1].replace(/\+/g, '%20')); // Replace + with %20
        queryParams[key] = value;
      });
    }
    if (queryParams['eventOfferId']) {
      const eventOfferIds = queryParams['eventOfferId'].split(',');
      const index = eventOfferIds.findIndex(value => value === event.Id);
      if (index !== -1) {
        if (queryParams['catId']) {
          const catIds = queryParams['catId'].split(',');
          catIds[index] = event.data[0].ciid;
          queryParams['catId'] = catIds.join(',');
        }

        if (queryParams['seats']) {
          const seats = queryParams['seats'].split(',');
          seats[index] = event.data[0].seats;
          queryParams['seats'] = seats.join(',');
        }
      }
    }
    const newQueryString = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${queryParams[key]}`)
      .join('&');
    const newUrl = `${baseUrl}?${newQueryString}`;
    this.location.replaceState(newUrl);
  }

  NavigateTo(url:string){
    this.data = HomePageUtils.finalizedObjectData(this.data);
    if (
      this.data.packageType != undefined &&
      this.data.packageType != null
    ) {
      this.params = { ...this.data, ...this.params };
    } else {
      this.routerService.navigate(PagesRoute.HomePage);
    }
    let copyFormDetails: any = { ...this.params };
    const pipe = new DatePipe("en-US");
    copyFormDetails.inboundDate = pipe.transform(
      copyFormDetails.inbound.date,
      "yyyy-MM-dd"
    );
    copyFormDetails.outboundDate = pipe.transform(
      copyFormDetails.outbound.date,
      "yyyy-MM-dd"
    );
    copyFormDetails.paxesChildrenAges = "[]";
    
    const finalizedObject =
      HomePageUtils.finalizedObjectDataTemp(copyFormDetails);
    let forwardRoute = "";
    if(url === 'event'){
      forwardRoute = PagesRoute.EventPage;
    } else{
      forwardRoute = PagesRoute.FlightsPage;
    }

    let currentUrl = this.location.path();
    const urlParts = currentUrl.split('?');
    let baseUrl = urlParts[0];
    let queryParams = {};
    if (urlParts.length > 1) {
      const queryString = urlParts[1];
      const queryParts = queryString.split('&');
      queryParts.forEach(part => {
        const keyValue = part.split('=');
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1]);
        queryParams[key] = value;
      });
    }

    this.routerService.navigateAndAddParamsToUrl(
      queryParams,
      true,
      forwardRoute
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
